import './BrutalistButton2.css';

const BrutalistButton2 = ({ children, onClick, className }) => {
  return (
    <button onClick={onClick} className="brutalist-outer">
      <span className={`button_top ${className || ''}`}>{children}</span>
    </button>
  );
};

export default BrutalistButton2;
